import { render, staticRenderFns } from "./EnterPhoneNumber.vue?vue&type=template&id=34515ef2&scoped=true&"
import script from "./EnterPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./EnterPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./EnterPhoneNumber.vue?vue&type=style&index=0&id=34515ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34515ef2",
  null
  
)

export default component.exports